import { faCircleNotch, faBarcode } from '@fortawesome/free-solid-svg-icons'
import { Config } from 'final-form'
import { debounce } from 'lodash'
import { Component, Watch } from 'vue-property-decorator'
import * as _ from 'lodash'

import {
    Container,
    ContainerDataStore,
    ContainerStatus,
    Item,
    ItemDataStore,
    itemSelectors,
    MovementTypes,
    Wemi,
} from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

import { LinkableItem } from '@skinsoft/entity-data-store'
import { BarcodeSubscriber, ItemCard } from '@skinsoft/ui'
import { debounceTime, first } from 'rxjs/operators'
import { BarcodeReader, Field, Form } from '../..'
import { Subject } from 'rxjs'
import { containerSelectors } from '@skinsoft/entity-ui'

require('./all-item-display-form.scss')

export interface Values {
    location: string
    identifier: string
}

declare var ITEM_SEARCH_TYPES: string[]

@Component({
    components: {
        sBarcodeReader: BarcodeReader,
        sBarcodeSubscriber: BarcodeSubscriber,
        sItemCard: ItemCard,
    },
    props: {
        canChainAdd: Boolean,
        items: Array,
        maxItemNumber: Number,
        pending: Boolean,
        enableBarcodeSearch: {
            type: Boolean,
            default: true,
        },
        errorMessage: String,
    },
    template: require('./all-item-display-form.html'),
})
export class AllItemDisplayForm extends ReactiveVue {
    public onSubmit: Config['onSubmit']
    public locations: Array<{ id: string; value: string; text: string }>
    public initialValues: Values
    public container: Container = null as any
    public movementType: MovementTypes
    public canChainAdd: boolean
    public statusesToSearch: ContainerStatus[]
    public enableBarcodeSearch: boolean

    public containerSelectors = containerSelectors
    public itemSelectors = itemSelectors

    public MovementTypes = MovementTypes

    public $refs: {
        barcodeReader: BarcodeReader
        form: Form
        location: Field
    }

    private searchTextValue$ = new Subject()
    private searchText: string = null as any
    private pending: boolean
    private readonly pageSize: number = 15
    private items: Array<Item | Container>
    private isBarcodeReaderActive = false
    private currentPageIndex = 0
    private maxItemNumber = 0

    private selectedItemIndex = -1

    private readonly INPUT_FILTER_IDENTIFIER: string = 'add-item-search-query-input'

    // Icons
    private loadingIcon = faCircleNotch
    private barcodeIcon = faBarcode

    private mounted() {
        this.subscribeTo(this.searchTextValue$.pipe(debounceTime(750)), searchText => {
            this.$emit('search', this.searchText, 0)
        })
        this.searchText = ''
    }

    private incrementPageIndex() {
        this.currentPageIndex =
            this.currentPageIndex + 1 > this.lastPageIndex
                ? this.lastPageIndex
                : this.currentPageIndex + 1
        this.$emit('search', this.searchText, this.currentPageIndex)
    }

    private decrementPageIndex() {
        this.currentPageIndex = this.currentPageIndex - 1 < 0 ? 0 : this.currentPageIndex - 1
        this.$emit('search', this.searchText, this.currentPageIndex)
    }

    @Watch('searchText')
    private onSearchTextChange() {
        this.searchTextValue$.next(this.searchText)
    }

    private get lastPageIndex() {
        return Math.ceil(this.maxItemNumber / this.pageSize)
    }

    private toggleBarcodeReader() {
        this.isBarcodeReaderActive = !this.isBarcodeReaderActive
    }

    private onBarcodeReaderInput(value: string) {
        this.searchText = value
        this.isBarcodeReaderActive = false
    }

    private onItemSelected(item, index) {
        this.selectedItemIndex = index
        this.$emit('item-selected', { id: item.id, type: item.entityType || item.type })
    }

    private getTitle(item: Item | Container): string {
        return _.get(item, 'entityType', _.get(item, 'type'))
            .toLowerCase()
            .includes('container')
            ? containerSelectors.title(item as Container)
            : itemSelectors.title(item as Item, this.$i18n.locale)
    }

    private getFutureLocation(item: Item | Container): string {
        return _.get(item, 'entityType', _.get(item, 'type'))
            .toLowerCase()
            .includes('container')
            ? containerSelectors.futureLocation(item as Container)?.path
            : itemSelectors.futureLocation(item as Item)?.path
    }
}
